export function Shop(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52"
      height="55"
      viewBox="0 0 52 55"
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_d_1579_50667)">
        <path
          d="M12.1358 25.8658C12.4866 21.5005 12.662 19.3179 14.0983 17.9923C15.5347 16.6667 17.7244 16.6667 22.1037 16.6667H29.8963C34.2756 16.6667 36.4653 16.6667 37.9017 17.9923C39.338 19.3179 39.5134 21.5005 39.8642 25.8658L40.1321 29.1991C40.5383 34.2544 40.7414 36.782 39.2565 38.3911C37.7716 40.0001 35.2358 40.0001 30.1642 40.0001H21.8358C16.7642 40.0001 14.2284 40.0001 12.7435 38.3911C11.2586 36.782 11.4617 34.2544 11.8679 29.1991L12.1358 25.8658Z"
          fill="currentColor"
          fillOpacity="0.1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.2511 13.3333C22.2511 11.2622 23.93 9.58325 26.0011 9.58325C28.0721 9.58325 29.7511 11.2622 29.7511 13.3333V15.4167H22.2511V13.3333ZM19.7511 17.9273V19.9999C19.7511 20.6903 20.3107 21.2499 21.0011 21.2499C21.6914 21.2499 22.2511 20.6903 22.2511 19.9999V17.9167H29.7511V19.9999C29.7511 20.6903 30.3107 21.2499 31.0011 21.2499C31.6914 21.2499 32.2511 20.6903 32.2511 19.9999V17.9273C33.2937 17.9426 34.1353 17.9801 34.8425 18.072C35.982 18.2202 36.6006 18.4917 37.055 18.9109C37.5093 19.3302 37.8295 19.9251 38.0684 21.0491C38.3148 22.2082 38.4412 23.7496 38.6193 25.9659L38.8871 29.2992C39.0932 31.8635 39.2345 33.6574 39.1566 35.0158C39.0807 36.3383 38.8044 37.039 38.339 37.5433C37.8735 38.0477 37.1972 38.3792 35.8851 38.5608C34.5372 38.7473 32.7378 38.7501 30.1653 38.7501H21.8369C19.2643 38.7501 17.4649 38.7473 16.117 38.5608C14.8049 38.3792 14.1286 38.0477 13.6632 37.5433C13.1977 37.039 12.9214 36.3383 12.8455 35.0158C12.7676 33.6574 12.9089 31.8635 13.115 29.2992L13.3828 25.9659C13.5609 23.7496 13.6873 22.2082 13.9337 21.0491C14.1727 19.9251 14.4928 19.3302 14.9472 18.9109C15.4015 18.4917 16.0201 18.2202 17.1597 18.072C17.8668 17.9801 18.7084 17.9426 19.7511 17.9273ZM19.7511 15.4268V13.3333C19.7511 9.88147 22.5493 7.08325 26.0011 7.08325C29.4528 7.08325 32.2511 9.88147 32.2511 13.3333V15.4268C33.3643 15.4428 34.3316 15.4845 35.1648 15.5929C36.574 15.7761 37.7684 16.1674 38.7505 17.0737C39.7325 17.9801 40.2182 19.1392 40.5138 20.5293C40.7979 21.8659 40.9348 23.57 41.1043 25.6788L41.1112 25.7656L41.3791 29.099L41.3868 29.1942L41.3868 29.1943C41.5834 31.641 41.7415 33.6077 41.6525 35.159C41.5602 36.7665 41.1956 38.1341 40.1762 39.2388C39.1567 40.3435 37.8227 40.8165 36.2277 41.0372C34.6885 41.2501 32.7155 41.2501 30.2609 41.2501H30.2608H30.1653H21.8369H21.7413H21.7412C19.2866 41.2501 17.3136 41.2501 15.7744 41.0372C14.1795 40.8165 12.8454 40.3435 11.826 39.2388C10.8065 38.1341 10.4419 36.7665 10.3497 35.159C10.2606 33.6077 10.4187 31.641 10.6154 29.1943L10.623 29.099L10.8909 25.7656L10.8979 25.6787C11.0673 23.57 11.2042 21.8659 11.4884 20.5293C11.7839 19.1392 12.2696 17.9801 13.2517 17.0737C14.2337 16.1674 15.4281 15.7761 16.8373 15.5929C17.6705 15.4845 18.6378 15.4428 19.7511 15.4268Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1579_50667"
          x="-4"
          y="-1.66654"
          width="60"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.33333" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1579_50667"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1579_50667"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
